module.exports = "/images/cooper-4.jpg";